import * as Joi from 'joi'

export const loginSchema = Joi.object({
  login: Joi.string()
    .email({ tlds: { allow: false } })
    .required()
    .messages({
      'string.email': 'Um email segue o formato: nome@domínio.com',
      'string.empty': 'O E-mail precisa ser preenchido',
    }),
  password: Joi.string().required().messages({
    'string.empty': 'A Senha precisa ser preenchida',
  }),
})
